import { connect } from 'react-redux';
import { compose } from 'redux';

import withReducer from '@Hooks/withReducer';
import { open as openHeatmapIndicator, fullScreenMode as heatmapFullScreenModeIndicator } from '@Pages/Heatmap/selectors';
import { setDrawingFromResults } from '@Containers/ResultsFilters/ResultsFiltersComponents/StructureFilter/StructureFilterActions';
import { summarySelectedItems as summarySelectedItemsSelector } from '@Pages/Results/selectors';
import { resolveAssistantEligibility } from '@Containers/Summary/assistantEligibility';
import { resolveSummaryChain } from '@Containers/Summary/summaryContext';
import { getSummaries, getSummaryAttempt } from '@Containers/Summary/selectors';
import { generateSummary as generateSummaryAction } from '@Containers/Summary/actions';
import { disableButtons as disableFilterButtons } from '@Containers/ResultsFilters/ResultsFiltersComponents/ResultsFiltersButtons/ResultsFiltersButtonsSelectors';
import openCloseResultsFiltersHOC from './OpenCloseResultsFiltersHOC';
import ResultsFilters from './ResultsFilters';
import resultsFiltersReducer from './ResultsFiltersReducer';
import { resultsFiltersReducerKey } from './ResultsFiltersConstants';
import { open, appliedFilterSummary as appliedFilterSummarySelector } from './ResultsFiltersSelectors';
import { setOpenFilters } from './ResultsFiltersActions';
import hasFocusedSummaryState from './ResultsFiltersFocusMode';

// AR-7.3: one drawer instance serves both views, so this container now also resolves whether the
// Assistant view has a visible or loading summary — that's exactly what drives FR-7.4's
// 372px/460px focus mode —
// rather than duplicating the chain-key computation in a second place.
function mapStateToProps(state, { activeBreadcrumb, params }) {
  const { rootBreadcrumb, chainKey } = resolveSummaryChain(activeBreadcrumb, params?.databaseId);

  return {
    open: open(state),
    openHeatmapIndicator: openHeatmapIndicator(state),
    heatmapFullScreenModeIndicator: heatmapFullScreenModeIndicator(state),
    assistantEligible: resolveAssistantEligibility(activeBreadcrumb, rootBreadcrumb),
    isFocusMode: hasFocusedSummaryState(getSummaries(state, chainKey), getSummaryAttempt(state, chainKey)),
    selectedItems: summarySelectedItemsSelector(state),
    chainKey,
    appliedFilterSummary: appliedFilterSummarySelector(state),
    hasSelectedFilters: !disableFilterButtons(state),
  };
}

const mapDispatchToProps = {
  setOpenFilters,
  setDrawingFromResults,
  generateSummary: generateSummaryAction,
};

export default compose(
  withReducer(resultsFiltersReducerKey, resultsFiltersReducer, true),
  connect(mapStateToProps, mapDispatchToProps),
  openCloseResultsFiltersHOC
)(ResultsFilters);
